export * from "@/ui/components/typography/TextHero";
export * from "@/ui/components/typography/TextTitle";
